<template>
    <Drawer @onClose="closeCallback">
        <div class="flex items-center justify-between p-4">
            <p class="flex items-center gap-2 text-eureka-500">
                <span class="text-lg" v-show="!projectDrawerListSerIns.loading">{{ projectDrawerListSerIns.total
                }}</span>
                <span v-html="title" class="text-sm text-black"></span>
            </p>
        </div>

        <CatLoading v-if="projectDrawerListSerIns.loading" class="mx-auto mt-40" />

        <div v-else-if="projectDrawerListSerIns.isEmpty" class="mt-40 flex justify-center">
            <CatHole2 class="mb-2 h-[50px] w-[70px]" />
            <span class="text-sm text-grey-90">
                {{ t('noData') }}
            </span>
        </div>

        <div v-else class="flex h-full flex-col gap-4 overflow-y-auto px-4 pb-4" ref="rightAside"
             @scroll="handleContentScroll">
            <SolutionCard :with-border="true" :order="index + 1" :solution="item"
                          v-for="(item, index) in projectDrawerListSerIns.list" :key="item.SOLUTION_ID" />
            <div v-if="projectDrawerListSerIns.moreLoading" class="mx-auto">
                <span class="th-loading th-loading-spinner th-loading-md"></span>
            </div>
        </div>
    </Drawer>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { SolutionCard } from '@eureka/solution-card';
import type { IRightListComponentData } from '@/types';
import { Drawer } from '@eureka/drawer'
import { CatLoading, CatHole2 } from '@eureka/cat'
import { ProjectDrawerListService } from '@/services/project-drawer-list-service';

import { useI18n } from 'vue-i18n';
const { t } = useI18n()

const props = defineProps<{
    title: string;
    closeCallback: () => void;
    data?: IRightListComponentData;
}>()

const rightAside = ref(null)
const projectDrawerListSerIns = ref(new ProjectDrawerListService(rightAside as unknown as HTMLDivElement))

onMounted(() => {
    projectDrawerListSerIns.value.loadInitialData({
        ...props.data,
    })
})

function handleContentScroll() {
    projectDrawerListSerIns.value.handleScroll({
        ...props.data,
    })
}

</script>
